/** Diagnósticos con su CIE-10 que acepta el certificado odontológico para validar en el IESS (lista entregada por la clínica; el texto va tal como la entregó). */
export const DIAGNOSTICOS_IESS: readonly (readonly [codigo: string, diagnostico: string])[] = [
  ["B002", "GINGIVOESTOMATITIS Y FARINGOAMIGDALITIS HERPETICA"],
  ["B009", "INFECCION DEBIDA A EL VIRUS DEL HERPES, NO ESPECIFICADA"],
  ["B99", "OTRAS ENFERMEDADES INFECCIOSAS Y LAS NO ESPECIFICADAS"],
  ["C068", "LESION DE SITIOS CONTIGUOS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA BOCA"],
  ["C088", "LESION DE SITIOS CONTIGUOS DE LAS GLANDULAS SALIVALES MAYORES"],
  ["G500", "NEURALGIA DEL TRIGEMINO"],
  ["G501", "DOLOR FACIAL ATIPICO"],
  ["G508", "OTROS TRASTORNOS DEL TRIGEMINO"],
  ["G510", "PARALISIS DE BELL"],
  ["J320", "SINUSITIS MAXILAR CRONICA"],
  ["K000", "ANODONCIA"],
  ["K001", "DIENTES SUPERNUMERARIOS"],
  ["K002", "ANOMALIAS DEL TAMANO Y DE LA FORMA DEL DIENTE"],
  ["K003", "DIENTES MOTEADOS"],
  ["K004", "ALTERACIONES EN LA FORMACION DENTARIA"],
  ["K005", "ALTERACIONES HEREDITARIA DE LA ESTRUCTURA DENTARIA, NO CLASIFICADAS EN OTRA PARTE"],
  ["K006", "ALTERACIONES EN LA ERUPCION DENTARIA"],
  ["K007", "SINDROME DE LA ERUPCION DENTARIA"],
  ["K008", "OTROS TRASTORNOS DEL DESARROLLO DE LOS DIENTES"],
  ["K009", "TRASTORNOS DEL DESARROLLO DE LOS DIENTES, NO ESPECIFICADO"],
  ["K010", "DIENTES INCLUIDOS"],
  ["K011", "DIENTES IMPACTADOS"],
  ["K020", "CARIES LIMITADA AL ESMALTE"],
  ["K021", "CARIES DE LA DENTINA"],
  ["K022", "CARIES DEL CEMENTO"],
  ["K023", "CARIES DENTARIA DETENIDA"],
  ["K024", "ODONTOCLASIA"],
  ["K028", "OTRAS CARIES DENTALES"],
  ["K029", "CARIES DENTAL, NO ESPECIFICADA"],
  ["K030", "ATRICION EXCESIVA DE LOS DIENTES"],
  ["K031", "ABRASION DE LOS DIENTES"],
  ["K032", "EROSION DE LOS DIENTES"],
  ["K033", "REABSORCION PATOLOGICA DE LOS DIENTES"],
  ["K034", "HIPERCEMENTOSIS"],
  ["K035", "ANQUILOSIS DENTAL"],
  ["K036", "DEPOSITOS (ACRECIONES) EN LOS DIENTES"],
  ["K037", "CAMBIOS POSTERUPTIVOS DEL COLOR DE LOS TEJIDOS DENTALES DUROS"],
  ["K038", "OTRAS ENFERMEDADES ESPECIFICADAS DE LOS TEJIDOS DUROS DE LOS DIENTES"],
  ["K039", "ENFERMEDAD NO ESPECIFICADA DE LOS TEJIDOS DENTALES DUROS"],
  ["K040", "PULPITIS"],
  ["K041", "NECROSIS DE LA PULPA"],
  ["K042", "DEGENERACION DE LA PULPA"],
  ["K043", "FORMACION ANORMAL DEL TEJIDO DURO EN LA PULPA"],
  ["K044", "PERIODONTITIS APICAL AGUDA ORIGINADA EN LA PULPA"],
  ["K045", "PERIODONTITIS APICAL CRONICA"],
  ["K046", "ABSCESO PERIAPICAL CON FISTULA"],
  ["K047", "ABSCESO PERIAPICAL SIN FISTULA"],
  ["K048", "QUISTE RADICULAR"],
  ["K049", "OTRAS ENFERMEDADES Y LAS NO ESPECIFICADAS DE LA PULPA Y DEL TEJIDO PERIAPICAL"],
  ["K050", "GINGIVITIS AGUDA"],
  ["K051", "GINGIVITIS CRONICA"],
  ["K052", "PERIODONTITIS AGUDA"],
  ["K053", "PERIODONTITIS CRONICA"],
  ["K054", "PERIODONTOSIS"],
  ["K055", "OTRAS ENFERMEDADES PERIODONTALES"],
  ["K056", "ENFERMEDAD DE PERIODONTO, NO ESPECIFICADA"],
  ["K060", "RETRACCION GINGIVAL"],
  ["K061", "HIPERPLASIA GINGIVAL"],
  ["K062", "LESIONES DE LA ENCIA Y DE LA ZONA EDENTULA ASOCIADAS CON TRAUMATISMO"],
  ["K068", "OTROS TRASTORNOS ESPECIFICADOS DE LA ENCIA Y DE LA ZONA EDENTULA"],
  ["K069", "TRASTORNO NO ESPECIFICADO DE LA ENCIA Y DE LA ZONA EDENTULA"],
  ["K070", "ANOMALIAS EVIDENTES DEL TAMANO DE LOS MAXILARES"],
  ["K071", "ANOMALIAS DE LA RELACION MAXILOBASILAR"],
  ["K072", "ANOMALIAS DE LA REALCION ENTRE LOS ARCOS DENTARIOS"],
  ["K073", "ANOMALIAS DE LA POSICION DEL DIENTE"],
  ["K074", "MALOCLUSION DE TIPO NO ESPECIFICADO"],
  ["K075", "ANOMALIAS DENTOFACIALES FUNCIONALES"],
  ["K076", "TRASTORNOS DE LA ARTICULACION TEMPOROMAXILAR"],
  ["K078", "OTRAS ANOMALIAS DENTOFACIALES"],
  ["K079", "ANOMALIA DENTOFACIAL, NO ESPECIFICADA"],
  ["K080", "EXFOLIACION DE LOS DIENTES DEBIDA A CAUSAS SISTEMICAS"],
  ["K081", "PERDIDA DE DIENTES DEBIDA A ACCIDENTE, EXTRACCION O ENFERMEDAD PERIODONTAL LOCAL"],
  ["K082", "ATROFIA DE REBORDE ALVEOLAR DESDENTADO"],
  ["K083", "RAIZ DENTAL RETENIDA"],
  ["K088", "OTRAS AFECCIONES ESPECIFICADAS DE LOS DIENTES Y DE SUS ESTRUCTURAS DE SOSTEN"],
  ["K089", "TRASTORNO DE LOS DIENTES Y DE SUS ESTRUCTURAS DE SOSTEN, NO ESPECIFICADO"],
  ["K090", "QUISTES ORIGINADOS POR EL DESARROLLO DE LOS DIENTES"],
  ["K091", "QUISTES DE LAS FISURAS (NO ODONTOGENICOS)"],
  ["K092", "OTROS QUISTES DE LOS MAXILARES"],
  ["K098", "OTROS QUISTES DE LA REGION BUCAL, NO CLASIFICADOS EN OTRA PARTE"],
  ["K099", "QUISTE DE LA REGION BUCAL, SIN OTRA ESPECIFICACION"],
  ["K100", "TRASTORNOS DEL DESARROLLO DE LOS MAXILARES"],
  ["K101", "GRANULOMA CENTRAL DE CELULAS GIGANTES"],
  ["K102", "AFECCIONES INFLAMATORIAS DE LOS MAXILARES"],
  ["K103", "ALVEOLITIS DEL MAXILAR"],
  ["K108", "OTRAS ENFERMEDADES ESPECIFICADAS DE LOS MAXILARES"],
  ["K109", "ENFERMEDAD DE LOS MAXILARES, NO ESPECIFICADA"],
  ["K110", "ATROFIA DE GLANDULA SALIVAL"],
  ["K111", "HIPERTROFIA DE GLANDULA SALIVAL"],
  ["K112", "SIALADENITIS"],
  ["K113", "ABSCESO DE GLANDULA SALIVAL"],
  ["K114", "FISTULA DE GLANDULA SALIVAL"],
  ["K115", "SIALOLITIASIS"],
  ["K116", "MUCOCELE DE GLANDULA SALIVAL"],
  ["K117", "ALTERACIONES DE LA SECRECION SALIVAL"],
  ["K118", "OTRAS ENFERMEDADES DE LAS GLANDULAS SALIVALES"],
  ["K119", "ENFERMEDAD DE GLANDULA SALIVAL. NO ESPECIFICADA"],
  ["K120", "ESTOMATITIS AFTOSA RECURRENTE"],
  ["K121", "OTRAS FORMAS DE ESTOMATITIS"],
  ["K122", "CELULITIS Y ABSCESO DE BOCA"],
  ["K130", "ENFERMEDADES DE LOS LABIOS"],
  ["K131", "MORDEDURA DEL LABIO Y DE LA MEJILLA"],
  ["K132", "LEUCOPLASIA Y OTRAS ALTERACIONES DEL EPITELIO BUCAL, INCLUYENDO LA LENGUA"],
  ["K133", "LEUCOPLASIA PILOSA"],
  ["K134", "GRANULOMA Y LESIONES SEMEJANTES DE LA MUCOSA BUCAL"],
  ["K135", "FIBROSIS DE LA SUBMUCOSA BUCAL"],
  ["K136", "HIPERPLASIA IRRITATIVA DE LA MUCOSA BUCAL"],
  ["K137", "OTRAS LESIONES Y LAS NO ESPECIFICADAS DE LA MUCOSA BUCAL"],
  ["O293", "REACCION TOXICA A LA ANESTESIA LOCAL ADMINISTRADA DURANTE EL EMBARAZO"],
  ["Q351", "FISURA DEL PALADAR DURO"],
  ["Q353", "FISURA DEL PALADAR BLANDO"],
  ["Q355", "FISURA DEL PALADAR DURO Y DEL PALADAR BLANDO"],
  ["Q356", "FISURA DEL PALADAR, LINEA MEDIA"],
  ["Q357", "FISURA DE LA UVULA"],
  ["Q359", "FISURA DEL PALADAR, SIN OTRA ESPECIFICACION"],
  ["Q360", "LABIO LEPORINO, BILATERAL"],
  ["Q361", "LABIO LEPORINO, LINEA MEDIA"],
  ["Q369", "LABIO LEPORINO, UNILATERAL"],
  ["Q370", "FISURA DEL PALADAR DURO CON LABIO LEPORINO BILATERAL"],
  ["Q371", "FISURA DEL PALADAR DURO CON LABIO LEPORINO, UNILATERAL"],
  ["Q372", "FISURA DEL PALADAR BLANDO CON LABIO LEPORINO BILATERAL"],
  ["Q373", "FISURA DEL PALADAR BLANDO CON LABIO LEPORINO UNILATERAL"],
  ["Q374", "FISURA DEL PALADAR DURO Y DEL PALADAR BLANDO CON LABIO LEPORINO BILATERAL"],
  ["Q375", "FISURA DEL PALADAR DURO Y DEL PALADAR BLANDO CON LABIO LEPORINO UNILATERAL"],
  ["Q378", "FISURA DEL PALADAR CON LABIO LEPORINO BILATERAL, SIN OTRA ESPECIFICACION"],
  ["Q379", "FISURA DEL PALADAR CON LABIO LEPORINO UNILATERAL, SIN OTRA ESPECIFICACION"],
  ["Q380", "MALFORMACIONES CONGENITAS DE LOS LABIOS, NO CLASIFICADAS EN OTRA PARTE"],
  ["Q381", "ANQUILOGLOSIA"],
  ["Q382", "MACROGLOSIA"],
  ["Q383", "OTRAS MALFORMACIONES CONGENITAS DE LA LENGUA"],
  ["S024", "FRACTURA DEL MALAR Y DEL HUESO MAXILAR SUPERIOR"],
  ["S025", "FRACTURA DE LOS DIENTES"],
  ["S026", "FRACTURA DEL MAXILAR INFERIOR"],
  ["S030", "LUXACION DEL MAXILAR"],
  ["B378", "CANDIDIASIS DE OTROS SITIOS"],
  ["S032", "LUXACION DE DIENTE"],
  ["T180", "CUERPO EXTRAÑO EN LA BOCA"],
  ["T784", "ALERGIA NO ESPECIFICADA"],
  ["T882", "CHOQUE DEBIDA A ANESTESIA"],
  ["T885", "OTRAS COMPLICACIONES DE LA ANESTESIA"],
  ["T886", "ADMINISTRADO APROPIADAMENTE"],
  ["Y400", "EFECTOS ADVERSOS DE PENICILINAS"],
  ["Y401", "EFECTOS ADVERSOS DE CEFALOSPORINAS Y OTROS ANTIBIOTICOS BETALACTAMICOS"],
  ["Y403", "EFECTOS ADVERSOS DE LOS MACROLIDOS"],
  ["Y404", "EFECTOS ADVERSOS DE TETRACICLINAS"],
  ["Y405", "EFECTOS ADVERSOS DE AMINOGLICOSIDOS"],
  ["Y406", "EFECTOS ADVERSOS DE RIFAMICINAS"],
  ["Y407", "EFECTOS ADVERSOS DE ANTIBIOTICOS ANTIMICOTICOS USADOS SISTEMATICAMENTE"],
  ["Y408", "EFECTOS ADVERSOS DE OTROS ANTIBIOTICOS SISTEMICOS"],
  ["Y409", "EFECTOS ADVERSOS DE ANTIBIOTICO SISTEMICO NO ESPECIFICADO"],
  ["Y410", "EFECTOS ADVERSOS DE SULFONAMIDAS"],
  ["Y411", "EFECTOS ADVERSOS DE DROGAS ANTIMICOBACTERIANAS"],
  ["Y458", "EFECTOS ADVERSOS DE OTROS ANALGESICOS Y ANTIPIRETICOS"],
  ["Y484", "EFECTOS ADVERSOS DE ANESTESICOS NO ESPECIFICADOS"],
  ["Y850", "SECUELAS DE ACCIDENTE DE VEHICULO DE MOTOR"],
  ["Y86", "SECUELAS DE OTROS ACCIDENTES"],
  ["Y870", "SECUELAS DE LESIONES AUTOINFLIGIDAS"],
  ["Y871", "SECUELAS DE AGRESIONES"],
  ["Z012", "EXAMEN ODONTOLOGICO"],
  ["Z463", "PRUEBA Y AJUSTE DE PROTESIS DENTAL"],
  ["Z464", "PRUEBA Y AJUSTE DE DISPOSITIVO ORTODONCICO"],
  ["Z965", "PRESENCIA DE IMPLANTES DE RAIZ DE DIENTE Y DE MANDIBULA"],
  ["B370", "ESTOMATITIS CANDIDIASICA"],
];
